<template>
  <!-- 韩文标签资料 — 화주·바코드별 식검(식품) / KC 한글표시사항 + KC 인증서류(2026-10-07 YZY).
       여기 적어 두면 入库处理 에서 그 바코드를 열 때 「打印韩文标签」 버튼이 뜨고, 箱单发票列表 에서 그 세트의 KC 서류를 내려받는다.
       항목 이름은 구매요청 「한글표시사항」과 같은 키(라벨 템플릿이 같은 키를 읽는다) — 소비기한·보관방법·모델명·KC인증번호·제조연월만 새로 더했다 -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">{{ pageTitle }}</h4>
          </div>
          <div class="card-body">
            <small class="text-muted d-block mb-2">
              按货主·条码登记食检/KC韩文标示，入库处理扫描该条码时可直接打印韩文标签；KC证书在箱单发票列表该套下载(화주·바코드별로 식검/KC 한글표시사항을 등록하면 입고처리에서 그 바코드를 열 때 바로 라벨을 출력할 수 있고, KC 인증서류는 箱单发票列表 그 세트에서 내려받습니다).
            </small>
            <div class="d-flex align-items-center flex-wrap cpl__gap mb-2">
              <label class="mb-0 small">货主(화주)</label>
              <select v-model="filterCompany" class="form-control form-control-sm" style="width:200px" @change="load">
                <option value="">全部(전체)</option>
                <option v-for="c in allCompanyids" :key="'f' + c" :value="c">{{ c }}</option>
              </select>
              <label class="mb-0 small">搜索(검색)</label>
              <input v-model.trim="keyword" type="search" class="form-control form-control-sm" style="width:220px" placeholder="条码·商品名(바코드·상품명)" @keyup.enter="load">
              <b-button size="sm" variant="outline-secondary" :disabled="loading" @click="load">查询(조회)</b-button>
              <b-button size="sm" variant="primary" @click="openEdit(null)">➕ 新增(등록)</b-button>
              <b-spinner v-if="loading" small></b-spinner>
              <span class="small text-muted">共 {{ list.length }} 条</span>
            </div>
            <div v-if="error" class="text-danger small mb-2">{{ error }}</div>

            <!-- 订单号 검색(2026-10-07 YZY) — 주문번호·바코드로 구매요청 상품을 찾아 하나 고르면 그 한글표시사항을 폼에 채운다.
                 표시사항을 통째로 붙여넣어도 된다: 맨 앞 코드로 찾고, 고른 상품의 수정 창에서 인식 결과를 확인 후 적용 -->
            <div class="border rounded p-2 mb-2 cpl__search">
              <div class="d-flex align-items-start flex-wrap cpl__gap">
                <label class="mb-0 small font-weight-bold pt-1">🔎 订单号查找(주문번호로 찾기)</label>
                <textarea v-model="search.text" rows="2" class="form-control form-control-sm cpl__search-input"
                  placeholder="订单号 2610070856 · 商品订单号 26100708560001 · 1688订单号 5127299823656008329 · 商家订单号 · 条码 R242166510002，或整段粘贴韩文标示(주문번호·상품주문번호·1688주문번호·판매처주문번호·바코드, 또는 표시사항 통째 붙여넣기)"
                  @keydown.enter.exact.prevent="runSearch"></textarea>
                <b-button size="sm" variant="primary" :disabled="search.busy || !search.text.trim()" @click="runSearch">查找(찾기)</b-button>
                <b-button v-if="search.text || search.list.length" size="sm" variant="outline-secondary" @click="clearSearch">清空(지우기)</b-button>
                <b-spinner v-if="search.busy" small></b-spinner>
              </div>
              <div v-if="search.msg" class="small mt-1" :class="search.msgClass">{{ search.msg }}</div>
              <div v-if="search.parsed" class="small mt-1 text-info">
                📋 已识别粘贴内容 {{ search.parsed.items.length }} 项{{ search.parsed.code ? '，编号 ' + search.parsed.code : '' }} — 选择下面的商品后，在编辑窗口确认并应用(붙여넣은 표시사항 {{ search.parsed.items.length }}개 항목을 인식했습니다. 아래 상품을 고르면 수정 창에서 확인 후 적용합니다)
                <b-button size="sm" variant="link" class="p-0 ml-1 align-baseline" @click="openFromPaste">不关联采购，直接新增(구매요청 없이 새로 등록)</b-button>
              </div>
              <div v-if="search.list.length" class="table-responsive mt-2 cpl__result">
                <table class="table table-sm table-bordered table-hover mb-0 small">
                  <thead class="thead-light">
                    <tr>
                      <th>货主(화주)</th><th>图片(이미지)</th><th>条码(바코드)</th>
                      <th style="min-width:220px">商品名(상품명)</th><th>1688商家(1688판매자)</th><th>链接(링크)</th><th>采购韩文标示(구매요청 표시사항)</th><th>申请日(요청일)</th><th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in search.list" :key="'s' + r._id">
                      <td>{{ r.companyid }}</td>
                      <td><img v-if="r.이미지" :src="cdnImg(r.이미지)" alt="" style="width:48px;height:48px;object-fit:cover" class="rounded"></td>
                      <td class="text-nowrap">{{ r.바코드 }}</td>
                      <td>{{ r.상품명 }}<div v-if="r.옵션 || r.옵션2" class="text-muted">{{ [r.옵션, r.옵션2].filter(Boolean).join(' / ') }}</div></td>
                      <td>{{ r.판매자명 }}</td>
                      <td class="text-nowrap"><a v-if="/^https?:\/\//.test(r.링크)" :href="r.링크" target="_blank" rel="noopener">链接(링크)</a><span v-else class="text-muted">—</span></td>
                      <td>
                        <span v-if="reqLabelCount(r)" class="badge badge-light">{{ reqLabelCount(r) }} 项(항목)</span>
                        <span v-else class="text-muted">—</span>
                        <span v-if="r.registered" class="badge badge-success ml-1">已登记(등록됨)</span>
                      </td>
                      <td class="text-nowrap">{{ fmtDay(r.요청일) }}</td>
                      <td class="text-nowrap"><b-button size="sm" variant="primary" class="py-0" :disabled="!r.바코드" @click="pickReq(r)">选择(선택)</b-button>
                        <div v-if="!r.바코드" class="text-danger small">该商品的条码客户还没有填写，请联系客户在采购申请中补填条码后再选择</div></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="table-responsive cpl__table">
              <table class="table table-sm table-bordered mb-0 small">
                <thead class="thead-light">
                  <tr>
                    <th>货主(화주)</th><th>条码(바코드)</th><th style="min-width:200px">商品名(상품명)</th>
                    <th>食检标签(식검)</th><th style="min-width:200px">KC标签·证书(KC·인증서류)</th><th>卫生检疫标签(위생검역)</th><th>更新(수정일)</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in list" :key="r._id">
                    <td>{{ r.companyid }}</td>
                    <td class="text-nowrap">{{ r.barcode }}</td>
                    <td>{{ r.상품명 || (r.food && r.food.제품명) || (r.kc && r.kc.제품명) || (r.hyg && r.hyg.제품명) || '' }}<span v-if="r.fixedPriceUSD" class="badge badge-warning ml-1" title="箱单发票按此金额申报(箱单发票 생성 시 이 금액을 申报单价로 사용)">申报金额 ${{ r.fixedPriceUSD }}</span><span v-if="r.confirmedNameEn" class="badge badge-info ml-1" :title="'确认英文品名(확정 영문 품명): ' + r.confirmedNameEn">英文品名✓</span><span v-if="r.hyg" class="badge badge-success ml-1" title="卫生检疫标签已登记(위생검역 라벨 등록)">卫生检疫✓</span></td>
                    <td class="text-center"><span v-if="r.food" class="badge badge-success">已登记(등록)</span><span v-else class="text-muted">—</span></td>
                    <td>
                      <div class="text-center"><span v-if="r.kc" class="badge badge-info">已登记(등록)</span><span v-else class="text-muted">—</span></div>
                      <div v-for="f in r.kcFiles || []" :key="f.fileId"><a href="#" @click.prevent="downloadFile(f)">📎 {{ f.name }}</a></div>
                    </td>
                    <td class="text-center"><span v-if="r.hyg" class="badge badge-secondary">已登记(등록)</span><span v-else class="text-muted">—</span></td>
                    <td class="text-nowrap">{{ fmtDate(r.updatedAt) }}<div class="text-muted">{{ r.updatedBy }}</div></td>
                    <td class="text-nowrap"><b-button size="sm" variant="outline-primary" class="py-0" @click="openEdit(r)">编辑(수정)</b-button></td>
                  </tr>
                  <tr v-if="!list.length && !loading"><td colspan="8" class="text-center text-muted py-4">没有记录(등록된 표시사항이 없습니다)</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 등록·수정 -->
    <b-modal v-model="edit.show" size="xl" :title="edit.isNew ? '新增韩文标签(한글표시사항 등록)' : '编辑韩文标签(한글표시사항 수정) — ' + edit.companyid + ' / ' + edit.barcode" hide-footer>
      <div class="d-flex align-items-center flex-wrap cpl__gap mb-2">
        <label class="mb-0 small">货主(화주)</label>
        <input v-model.trim="edit.companyid" list="cplCompanies" class="form-control form-control-sm" :class="fcls(edit.companyid)" style="width:180px" :disabled="!edit.isNew">
        <datalist id="cplCompanies"><option v-for="c in allCompanyids" :key="'d' + c" :value="c"></option></datalist>
        <label class="mb-0 small">条码号(바코드)</label>
        <input v-model.trim="edit.barcode" class="form-control form-control-sm" :class="fcls(edit.barcode)" style="width:180px" :disabled="!edit.isNew">
        <span v-if="!isFilled(edit.barcode)" class="badge badge-warning cpl__tag">未填(미입력)</span>
        <label class="mb-0 small">韩文品名(한글 품명)</label>
        <input v-model.trim="edit.상품명" class="form-control form-control-sm" :class="fcls(edit.상품명)" style="width:260px">
        <span v-if="!isFilled(edit.상품명)" class="badge badge-warning cpl__tag">未填(미입력)</span>
        <b-button size="sm" variant="outline-info" :disabled="!edit.companyid || !edit.barcode || edit.busy" @click="loadFromReq">从采购记录带出(구매요청에서 불러오기)</b-button>
      </div>
      <!-- 고정 申报金额(2026-10-11 YZY) — 식검/KC 와 무관하게 입력. 있으면 箱单发票 申报单价·出库资料 价格USD 가 이 값(개당 USD) -->
      <div class="d-flex align-items-center flex-wrap cpl__gap mb-2">
        <label class="mb-0 small font-weight-bold">申报金额(신고금액 USD/件)</label>
        <input v-model.trim="edit.fixedPriceUSD" @input="edit.msg = ''" type="number" min="0" step="0.0001" class="form-control form-control-sm" :class="{ cpl__filled: isFilled(edit.fixedPriceUSD) }" style="width:140px" placeholder="USD">
        <small class="text-muted">留空=不固定。填写后生成箱单发票时，该条码的申报单价固定为此金额(合包也不乘N，行显示黄色)；已生成的旧箱单发票不变(비우면 고정 안 함. 적으면 箱单发票 생성 때 이 바코드의 申报单价가 이 금액으로 고정되고 합포장도 ×N 안 함·노란 행. 이미 만든 서류는 그대로)</small>
        <small v-if="edit.fixedLog" class="text-muted">最近修改(최근 변경): {{ fmtDate(edit.fixedLog.at) }} · {{ edit.fixedLog.by }} · 原值(이전 값) {{ edit.fixedLog.from == null ? '—' : '$' + edit.fixedLog.from }}</small>
      </div>
      <!-- 확정 영문 품명(2026-10-16 YZY #27) — 같은 화주+바코드는 하나로. 있으면 箱单发票·产地证 의 영어품명이 이 값(통관업체 반려 후 한 번만 고치면 다음 발송부터 자동) -->
      <div class="d-flex align-items-center flex-wrap cpl__gap mb-2">
        <label class="mb-0 small font-weight-bold">确认英文品名(확정 영문 품명)</label>
        <input v-model.trim="edit.confirmedNameEn" @input="edit.msg = ''" type="text" maxlength="200" class="form-control form-control-sm" :class="{ cpl__filled: isFilled(edit.confirmedNameEn) }" style="width:360px" placeholder="English product name">
        <small class="text-muted">留空=用采购申请时填写的英文品名。填写后该客户+条码生成箱单发票和产地证时都使用此品名；已生成的旧文件不变(비우면 구매신청 때 입력한 영문명 사용. 적으면 이 화주+바코드의 箱单发票·产地证 영문 품명이 이 값. 이미 만든 서류는 그대로)</small>
        <small v-if="edit.nameLog" class="text-muted">最近修改(최근 변경): {{ fmtDate(edit.nameLog.at) }} · {{ edit.nameLog.by }} · 原值(이전 값) {{ edit.nameLog.from || '—' }}</small>
      </div>
      <div class="d-flex align-items-center flex-wrap cpl__gap mb-2">
        <label class="mb-0 small font-weight-bold">标签类型(라벨 종류)</label>
        <b-form-radio-group v-model="edit.mode" :options="MODES" buttons size="sm" button-variant="outline-primary"></b-form-radio-group>
        <small v-if="edit.mode === 'none'" class="text-muted">未选择=不需要食检/KC/卫生检疫标签(点击上面按钮才会出现对应输入栏)(선택 안 함 = 식검·KC·위생검역 라벨 없음. 위 버튼을 눌러야 해당 입력칸이 나타납니다)</small>
        <small class="text-muted">选择食检则隐藏KC部分，选择KC则隐藏食检部分(식검을 고르면 KC 칸이, KC를 고르면 식검 칸이 숨겨집니다. 바코드·한글 품명은 항상 표시)</small>
      </div>
      <div v-if="edit.msg" class="small mb-2" :class="edit.msgClass">{{ edit.msg }}</div>
      <!-- 붙여넣기 자동 인식 — 한 덩어리 표시사항을 라벨 사전으로 칸별로 나눠 미리보기 → 확인 후 폼에 적용 -->
      <div class="mb-2">
        <b-button size="sm" :variant="edit.paste.show ? 'secondary' : 'outline-secondary'" @click="edit.paste.show = !edit.paste.show">📋 粘贴自动识别(붙여넣기 자동 인식)</b-button>
      </div>
      <div v-if="edit.paste.show" class="border rounded p-2 mb-2 cpl__paste">
        <textarea v-model="edit.paste.text" rows="3" class="form-control form-control-sm mb-1"
          placeholder="整段粘贴，例如: R242166510002 라면냄비 18cm 상품명 : 주방용품 수입원/판매원 : (주)쿠패스 제조국 : Made In China …(통째로 붙여넣으세요)"></textarea>
        <div class="d-flex align-items-center flex-wrap cpl__gap mb-1">
          <b-button size="sm" variant="outline-primary" :disabled="!edit.paste.text.trim()" @click="parsePaste">识别(인식)</b-button>
          <template v-if="edit.paste.result">
            <label class="mb-0 small">填入(넣을 칸)</label>
            <b-form-radio-group v-model="edit.paste.target" :options="PASTE_TARGETS" buttons size="sm" button-variant="outline-primary"></b-form-radio-group>
            <b-button size="sm" variant="success" :disabled="!edit.paste.result.items.length && !edit.paste.result.title" @click="applyPaste">应用到表单(폼에 적용)</b-button>
          </template>
        </div>
        <table v-if="edit.paste.result" class="table table-sm table-bordered mb-0 small cpl__preview">
          <thead class="thead-light"><tr><th style="width:22%">原文标签(붙여넣은 라벨)</th><th style="width:22%">对应栏(들어갈 칸)</th><th>内容(값)</th></tr></thead>
          <tbody>
            <tr v-if="edit.paste.result.code"><td>{{ edit.paste.result.codeType === 'barcode' ? '条码(바코드)' : '订单号(주문번호)' }}</td><td class="text-muted">—</td><td>{{ edit.paste.result.code }}</td></tr>
            <tr v-if="edit.paste.result.title"><td>显示名(표시명)</td><td>商品名(상품명)</td><td>{{ edit.paste.result.title }}</td></tr>
            <tr v-for="(it, i) in edit.paste.result.items" :key="'pv' + i" :class="{ 'table-warning': !it.key || it.key === '기타' }">
              <td>{{ it.label }}</td>
              <td>{{ fieldLabelOf(it.key) }}</td>
              <td class="cpl__pre">{{ it.value }}</td>
            </tr>
            <tr v-if="!edit.paste.result.items.length"><td colspan="3" class="text-muted text-center">没有识别到「标签 : 内容」(「라벨 : 값」을 찾지 못했습니다)</td></tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div v-show="showFood(edit.mode)" class="col-lg-8">
          <div class="border rounded p-2 mb-2">
            <div class="font-weight-bold mb-1">🍱 食检韩文标示(식검 — 식품 한글표시사항)</div>
            <small class="text-muted d-block mb-1">打印时显示「식품위생법에 의한 한글표시사항」和食品用标志(출력 시 식품용 마크·제목이 붙습니다). 全部空着=没有食检标签(모두 비우면 식검 라벨 없음).</small>
            <div v-for="f in FOOD_FIELDS" v-show="!f.hidden && (!f.legacy || edit.food[f.key])" :key="'fd' + f.key" class="form-group row mb-1">
              <label class="col-sm-4 col-form-label col-form-label-sm">{{ f.label }}<span v-if="!isFilled(edit.food[f.key])" class="badge badge-warning cpl__tag ml-1">未填</span></label>
              <div class="col-sm-8">
                <textarea v-if="f.multi" v-model="edit.food[f.key]" rows="2" class="form-control form-control-sm" :class="fcls(edit.food[f.key])" :placeholder="f.ph"></textarea>
                <input v-else v-model="edit.food[f.key]" class="form-control form-control-sm" :class="fcls(edit.food[f.key])" :placeholder="f.ph">
              </div>
            </div>
          </div>
        </div>
        <div v-show="showHyg(edit.mode)" class="col-lg-8">
          <div class="border rounded p-2 mb-2">
            <div class="font-weight-bold mb-1">🧼 卫生检疫韩文标示(위생검역 — 위생용품 관리법에 의한 품질 표시)</div>
            <small class="text-muted d-block mb-1">打印时显示「위생용품 관리법에 의한 품질 표시」(출력 시 이 제목이 붙습니다). 全部空着=没有卫生检疫标签(모두 비우면 위생검역 라벨 없음).</small>
            <div v-for="f in HYG_FIELDS" :key="'hy' + f.key" class="form-group row mb-1">
              <label class="col-sm-4 col-form-label col-form-label-sm">{{ f.label }}<span v-if="!isFilled(edit.hyg[f.key])" class="badge badge-warning cpl__tag ml-1">未填</span></label>
              <div class="col-sm-8">
                <textarea v-if="f.multi" v-model="edit.hyg[f.key]" rows="2" class="form-control form-control-sm" :class="fcls(edit.hyg[f.key])" :placeholder="f.ph"></textarea>
                <input v-else v-model="edit.hyg[f.key]" class="form-control form-control-sm" :class="fcls(edit.hyg[f.key])" :placeholder="f.ph">
              </div>
            </div>
          </div>
        </div>
        <div v-show="showKc(edit.mode)" class="col-lg-8">
          <div class="border rounded p-2 mb-2">
            <div class="font-weight-bold mb-1">🔌 KC认证韩文标示(KC인증 한글표시사항)</div>
            <small class="text-muted d-block mb-1">打印时显示KC标志(출력 시 KC 마크가 붙습니다). 全部空着=没有KC标签(모두 비우면 KC 라벨 없음).</small>
            <div v-for="f in KC_FIELDS" :key="'kc' + f.key" class="form-group row mb-1">
              <label class="col-sm-4 col-form-label col-form-label-sm">{{ f.label }}<span v-if="!isFilled(edit.kc[f.key])" class="badge badge-warning cpl__tag ml-1">未填</span></label>
              <div class="col-sm-8">
                <textarea v-if="f.multi" v-model="edit.kc[f.key]" rows="2" class="form-control form-control-sm" :class="fcls(edit.kc[f.key])" :placeholder="f.ph"></textarea>
                <input v-else v-model="edit.kc[f.key]" class="form-control form-control-sm" :class="fcls(edit.kc[f.key])" :placeholder="f.ph">
              </div>
            </div>
            <div class="mt-2">
              <div class="font-weight-bold small mb-1">📎 KC证书(KC 인증서류) — PDF·PNG·JPG, 10MB</div>
              <div v-for="f in edit.kcFiles" :key="'ef' + f.fileId" class="small">
                <a href="#" @click.prevent="downloadFile(f)">📎 {{ f.name }}</a>
                <span class="text-muted ml-1">{{ fmtDate(f.uploadedAt) }}</span>
                <a href="#" class="text-danger ml-2" @click.prevent="removeFile(f)">删除(삭제)</a>
              </div>
              <label class="btn btn-sm btn-outline-primary mb-0 mt-1" :class="{ disabled: !edit.companyid || !edit.barcode || edit.busy }">
                ⬆ 上传KC证书(인증서류 올리기)
                <input type="file" accept="application/pdf,image/png,image/jpeg" class="d-none" multiple :disabled="!edit.companyid || !edit.barcode || edit.busy" @change="onKcFile">
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end cpl__gap">
        <b-button v-if="!edit.isNew" size="sm" variant="outline-danger" class="mr-auto" :disabled="edit.busy" @click="removeLabel">删除(삭제)</b-button>
        <b-spinner v-if="edit.busy" small></b-spinner>
        <b-button size="sm" variant="secondary" @click="edit.show = false">关闭(닫기)</b-button>
        <b-button size="sm" variant="success" :disabled="!edit.companyid || !edit.barcode || edit.busy" @click="save">保存(저장)</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { coupassMenuTitle } from './coupassMenu';
import { parseLabelText, toSection, isFilled, showFood, showKc, showHyg, initialMode } from './coupassLabelParse';

// 키 = 구매요청 한글표시사항 키(+새 키). 서버 LABEL_FOOD_KEYS·LABEL_KC_KEYS 와 같은 목록
const FOOD_FIELDS = [
  { key: '제품명', label: '商品名(상품명)', ph: '예) 건조 망고' },
  { key: '수입원', label: '进口商(수입원)', ph: '예) (주)OO' },
  { key: '판매원', label: '销售商(판매원)', ph: '예) (주)OO 서울시 …' },
  // 예전에 저장된 값 보존용 — 값이 있을 때만 보인다
  { key: '수입원/판매원', label: '进口商/销售商(수입원/판매원·기존값)', ph: '', legacy: true },
  { key: '반품교환업무 소재지', label: '退换货地址(반품교환업무 소재지)', ph: '예) (주)OO 010-0000-0000 인천시 …' },
  { key: '제조원', label: '制造商(제조원)', ph: '예) OO食品有限公司' },
  { key: '제조국', label: '制造国(제조국)', ph: '예) 중국' },
  { key: '원료명및성분명(재질)', label: '材质(재질)', ph: '예) 스테인레스' },
  { key: '사용시주의사항', label: '注意事项(사용시주의사항)', ph: '예) 부정·불량식품 신고는 국번없이 1399' },
  // 화면에서만 숨김 — 이미 저장된 값은 그대로 보존해 다시 저장한다(YZY 10-07 소비기한·보관방법, 10-11 상품유형·내용량·기타)
  { key: '상품유형', label: '食品类型(식품유형)', ph: '', hidden: true },
  { key: '내용량', label: '净含量(내용량)', ph: '', hidden: true },
  { key: '소비기한', label: '保质期(소비기한)', ph: '', hidden: true },
  { key: '보관방법', label: '保存方法(보관방법)', ph: '', hidden: true },
  { key: '기타', label: '其他(기타)', ph: '', multi: true, hidden: true }
];
const KC_FIELDS = [
  { key: '제품명', label: '品名(품명)', ph: '예) 어린이용 우산' },
  { key: '모델명', label: '型号(모델명)', ph: '예) UM-100' },
  { key: 'KC인증번호', label: 'KC认证编号(KC 인증번호)', ph: '예) CB0XXXXX-0000' },
  { key: '수입원/판매원', label: '进口商(수입자)', ph: '예) (주)OO' },
  { key: '제조원', label: '制造商(제조자)', ph: '예) OO有限公司' },
  { key: '제조국', label: '制造国(제조국)', ph: '예) 중국' },
  { key: '제조연월', label: '制造年月(제조연월)', ph: '예) 2026.10' },
  { key: '원료명및성분명(재질)', label: '材质(재질)', ph: '예) 폴리에스터' },
  { key: '사용기준', label: '使用年龄(사용연령)', ph: '예) 14세 이상' },
  { key: '사용시주의사항', label: '注意事项(주의사항)', ph: '예) 용도 이외에 사용금지' },
  { key: '반품교환업무 소재지', label: '退换货地址(반품교환 소재지)', ph: '예) (주)OO 010-0000-0000 인천시 …' },
  { key: '기타', label: '其他(기타)', ph: '一行一项(한 줄에 「라벨: 값」 하나)', multi: true }
];
// 위생검역(2026-10-16 YZY) — 「위생용품 관리법에 의한 품질 표시」. 서버 LABEL_HYG_KEYS 와 같은 목록·순서(출력 순서)
const HYG_FIELDS = [
  { key: '제품명', label: '品名(제품명)', ph: '예) 다용도 극세사 행주 그레이 1+1' },
  { key: '내용량', label: '内容量(내용량)', ph: '예) 100매(25cm×25cm, 1겹)' },
  { key: '재질', label: '材质(재질)', ph: '예) 섬유' },
  { key: '제조국명', label: '制造国(제조국명)', ph: '예) 중국' },
  { key: '제조자명', label: '制造商(제조자명)', ph: '예) JINHUA YIRUI HOME FURNISHINGS CO., LTD.' },
  { key: '제조년월일', label: '制造日期(제조년월일)', ph: '예) 2026년8월11일' },
  { key: '수입자명', label: '进口商(수입자명)', ph: '예) (주)쿠패스 / 인천시 연수구 …' },
  { key: '위생용품유형', label: '卫生用品类型(위생용품유형)', ph: '예) 일회용 행주' },
  { key: '소비자상담실', label: '消费者咨询(소비자상담실)', ph: '예) 010 0000 0000' },
  { key: '반품 및 교환', label: '退换货(반품 및 교환)', ph: '예) 구입처' },
  { key: '사용시주의사항', label: '注意事项(사용시주의사항)', ph: '예) 용도 이외에 사용금지' },
  { key: '사용기준', label: '使用标准(사용기준)', ph: '예) 14세 이상' },
  { key: '기타', label: '其他(기타)', ph: '一行一项(한 줄에 「라벨: 값」 하나)', multi: true }
];
const MODES = [
  { value: 'food', text: '食检(식검)' },
  { value: 'kc', text: 'KC认证(KC인증)' },
  { value: 'hyg', text: '卫生检疫(위생검역)' }
];
const PASTE_TARGETS = [
  { value: 'food', text: '食检(식검)' },
  { value: 'kc', text: 'KC' },
  { value: 'both', text: '两个都(둘 다)' }
];
// 붙여넣기 미리보기 「들어갈 칸」 이름(키 → 폼 라벨)
const FIELD_LABELS = {};
FOOD_FIELDS.concat(KC_FIELDS).forEach(f => { if (!FIELD_LABELS[f.key]) FIELD_LABELS[f.key] = f.label; });
// 구매요청 한글표시사항 → 각 칸(같은 키만 옮긴다)
function emptyOf(fields, src) {
  const o = {};
  fields.forEach(f => { o[f.key] = (src && src[f.key]) || ''; });
  return o;
}
function fileToB64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
    reader.onerror = () => reject(new Error('文件读取失败(파일을 읽지 못했습니다)'));
    reader.readAsDataURL(file);
  });
}
function fileType(file) {
  if (file.type) return file.type === 'image/jpg' ? 'image/jpeg' : file.type;
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  return { pdf: 'application/pdf', png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg' }[ext] || '';
}

export default {
  name: 'CoupassProductLabel',
  data() {
    return {
      pageTitle: coupassMenuTitle('logis.productlabels'),
      FOOD_FIELDS,
      KC_FIELDS,
      HYG_FIELDS,
      PASTE_TARGETS,
      MODES,
      allCompanyids: [],
      filterCompany: '',
      keyword: '',
      list: [],
      loading: false,
      error: '',
      // 订单号 검색 — text 는 번호 하나 또는 표시사항 통째. parsed = 붙여넣기 인식 결과(라벨이 하나라도 있을 때)
      search: { text: '', busy: false, msg: '', msgClass: '', list: [], parsed: null },
      edit: this.emptyEdit()
    };
  },
  mounted() {
    this.loadCompanies();
    this.load();
  },
  methods: {
    // 쿠팡 CDN 이미지의 http·이중 슬래시는 403 이라 고친다(구매요청 화면과 같은 규칙)
    cdnImg(url) {
      if (typeof url !== 'string' || !url.includes('coupangcdn.com')) return url;
      return url.replace(/^http:\/\/([^/]*coupangcdn\.com)/, 'https://$1').replace(/(coupangcdn\.com\/image)\/{2,}/, '$1/');
    },
    emptyEdit() {
      return { show: false, isNew: true, companyid: '', barcode: '', 상품명: '', food: emptyOf(FOOD_FIELDS), kc: emptyOf(KC_FIELDS), hyg: emptyOf(HYG_FIELDS), kcFiles: [], fixedPriceUSD: '', fixedLog: null, confirmedNameEn: '', nameLog: null, busy: false, msg: '', msgClass: '', mode: 'none',
        paste: { show: true, text: '', result: null, target: 'both' } };
    },
    async loadCompanies() {
      try {
        const { data } = await axios.post('/api/getcompanyids', {});
        const list = (data && data.result) || [];
        // 쿠패스 화주만(营业执照管理 와 같은 기준 — auth.showimport)
        this.allCompanyids = [...new Set(list.filter(u => u.auth && u.auth.showimport).map(u => u.companyid).filter(Boolean))].sort();
      } catch (e) {
        console.error('companyid 목록 실패:', e);
      }
    },
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await axios.post('/api/coupassLabel/list', { companyid: this.filterCompany, keyword: this.keyword });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '查询失败');
        this.list = data.list || [];
      } catch (e) {
        console.error('韩文标签资料 조회 실패:', e);
        this.error = '查询失败(조회 실패): ' + e.message;
      } finally {
        this.loading = false;
      }
    },
    openEdit(r) {
      const e = this.emptyEdit();
      if (r) {
        Object.assign(e, { isNew: false, companyid: r.companyid, barcode: r.barcode, 상품명: r.상품명 || '', food: emptyOf(FOOD_FIELDS, r.food), kc: emptyOf(KC_FIELDS, r.kc), hyg: emptyOf(HYG_FIELDS, r.hyg), kcFiles: r.kcFiles || [], mode: initialMode(r), fixedPriceUSD: r.fixedPriceUSD > 0 ? String(r.fixedPriceUSD) : '', fixedLog: r.fixedPriceLog || null, confirmedNameEn: r.confirmedNameEn || '', nameLog: (r.confirmedNameLog || []).slice(-1)[0] || null });
      } else if (this.filterCompany) {
        e.companyid = this.filterCompany;
      }
      e.show = true;
      this.edit = e;
    },
    applyLabel(label) {
      if (!label) return;
      this.edit.isNew = false;
      this.edit.상품명 = label.상품명 || this.edit.상품명;
      this.edit.food = emptyOf(FOOD_FIELDS, label.food);
      this.edit.kc = emptyOf(KC_FIELDS, label.kc);
      this.edit.hyg = emptyOf(HYG_FIELDS, label.hyg);
      this.edit.kcFiles = label.kcFiles || [];
      this.edit.fixedPriceUSD = label.fixedPriceUSD > 0 ? String(label.fixedPriceUSD) : '';
      this.edit.fixedLog = label.fixedPriceLog || null;
      this.edit.confirmedNameEn = label.confirmedNameEn || '';
      this.edit.nameLog = (label.confirmedNameLog || []).slice(-1)[0] || null;
      this.edit.mode = initialMode(label);
    },
    isFilled,
    showFood,
    showKc,
    showHyg,
    // 입력된 칸/빈 칸 색 구분(2026-10-11 YZY) — 입력 즉시 반응
    fcls(v) { return isFilled(v) ? 'cpl__filled' : 'cpl__empty'; },
    // 이미 등록된 바코드면 그 값을, 없으면 같은 화주·바코드의 최근 구매요청 한글표시사항을 빈 칸에 채운다
    async loadFromReq() {
      this.edit.busy = true;
      this.edit.msg = '';
      try {
        const { data } = await axios.post('/api/coupassLabel/get', { companyid: this.edit.companyid, barcode: this.edit.barcode, withReq: true });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '查询失败');
        if (data.label && this.edit.isNew) {
          this.applyLabel(data.label);
          this.edit.msg = '该条码已登记，已载入(이미 등록된 바코드라 저장된 값을 불러왔습니다)';
          this.edit.msgClass = 'text-info';
          return;
        }
        const req = data.fromReq;
        if (!req) {
          this.edit.msg = '没有该条码的采购记录韩文标示(이 바코드의 구매요청 한글표시사항이 없습니다)';
          this.edit.msgClass = 'text-warning';
          return;
        }
        this.fillFromReq(req);
        this.edit.msg = '已从采购记录带出，请确认后保存(구매요청 값을 빈 칸에 채웠습니다. 확인 후 저장하세요)';
        this.edit.msgClass = 'text-success';
      } catch (e) {
        console.error('구매요청 한글표시사항 불러오기 실패:', e);
        this.edit.msg = '失败(실패): ' + e.message;
        this.edit.msgClass = 'text-danger';
      } finally {
        this.edit.busy = false;
      }
    },
    // 구매요청 한 건({상품명, 한글표시사항})의 값을 빈 칸에만 채운다 — 「불러오기」와 订单号 검색 「선택」이 같이 쓴다
    fillFromReq(req) {
      const src = (req && req.한글표시사항) || {};
      if (!this.edit.상품명) this.edit.상품명 = src.제품명 || req.상품명 || '';
      // 구매요청의 식품용·kc인증 스위치로 어느 칸에 넣을지 고른다(둘 다 꺼져 있으면 두 칸 모두)
      const targets = src.식품용 && !src.kc인증 ? ['food'] : (src.kc인증 && !src.식품용 ? ['kc'] : ['food', 'kc']);
      if (targets.length === 1 && this.edit.isNew) this.edit.mode = targets[0];
      let n = 0;
      targets.forEach(t => {
        const fields = t === 'food' ? FOOD_FIELDS : KC_FIELDS;
        fields.forEach(f => {
          const v = f.key === '제품명' ? (src.제품명 || req.상품명) : src[f.key];
          if (!this.edit[t][f.key] && v) { this.edit[t][f.key] = v; n++; }
        });
      });
      return n;
    },
    reqLabelCount(r) {
      const src = r.한글표시사항 || {};
      return FOOD_FIELDS.concat(KC_FIELDS).map(f => f.key).filter((k, i, a) => a.indexOf(k) === i && src[k]).length;
    },
    clearSearch() {
      this.search = { text: '', busy: false, msg: '', msgClass: '', list: [], parsed: null };
    },
    // 번호 하나면 그대로, 표시사항 통째면 맨 앞 코드로 찾는다(인식 결과는 고른 상품의 수정 창에 넘긴다)
    async runSearch() {
      // 상품 목록 화면에서 «商家: 번호» 를 복사해 붙인 경우 라벨을 뗀다
      const text = (this.search.text || '').replace(/^\s*商家\s*[:：]\s*/, '');
      const parsed = parseLabelText(text);
      const one = text.trim();
      const q = parsed.code || (!parsed.items.length && one && !/\s/.test(one) ? one : '');
      this.search.parsed = parsed.items.length ? parsed : null;
      this.search.list = [];
      this.search.msg = '';
      if (!q) {
        this.search.msg = parsed.items.length
          ? '粘贴内容开头没有订单号/条码，可直接新增(맨 앞에 주문번호·바코드가 없습니다 — 「구매요청 없이 새로 등록」을 누르세요)'
          : '请输入订单号或条码(주문번호나 바코드를 넣으세요)';
        this.search.msgClass = 'text-warning';
        return;
      }
      this.search.busy = true;
      try {
        const { data } = await axios.post('/api/coupassLabel/searchReq', { q, companyid: this.filterCompany });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '查询失败');
        this.search.list = data.list || [];
        const what = { order: '订单号(주문번호)', item: '商品订单号(상품주문번호)', order1688: '1688订单号(1688주문번호)', seller: '商家订单号(판매처주문번호)', barcode: '条码(바코드)' }[data.kind] || '';
        this.search.msg = this.search.list.length
          ? what + ' ' + q + ' — ' + this.search.list.length + ' 个商品，请选择一个(상품 ' + this.search.list.length + '개 — 하나를 고르세요)'
          : what + ' ' + q + ' — 没有找到采购记录(구매요청을 찾지 못했습니다)';
        this.search.msgClass = this.search.list.length ? 'text-success' : 'text-warning';
      } catch (e) {
        console.error('订单号 검색 실패:', e);
        this.search.msg = '查询失败(조회 실패): ' + e.message;
        this.search.msgClass = 'text-danger';
      } finally {
        this.search.busy = false;
      }
    },
    // 검색 결과에서 상품 하나 선택 → 이미 등록된 값이 있으면 그것부터, 빈 칸은 그 구매요청 한글표시사항으로 채운다
    async pickReq(r) {
      const e = this.emptyEdit();
      Object.assign(e, { companyid: r.companyid, barcode: r.바코드, show: true, busy: true });
      this.edit = e;
      try {
        const { data } = await axios.post('/api/coupassLabel/get', { companyid: r.companyid, barcode: r.바코드 });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '查询失败');
        if (data.label) this.applyLabel(data.label);
        const n = this.fillFromReq(r);
        const parts = [];
        if (data.label) parts.push('已载入已登记内容(등록된 값을 불러왔습니다)');
        parts.push(n ? '已用采购记录填空 ' + n + ' 项(구매요청 값으로 빈 칸 ' + n + '개를 채웠습니다)' : '采购记录没有可填的内容(구매요청에 채울 값이 없습니다)');
        if (this.search.parsed) {
          this.edit.paste = { show: true, text: this.search.text, result: null, target: 'both' };
          this.parsePaste();
          parts.push('粘贴内容请确认后点「应用到表单」(붙여넣은 내용은 확인 후 「폼에 적용」을 누르세요)');
        }
        this.edit.msg = parts.join(' · ') + ' — 确认后保存(확인 후 저장하세요)';
        this.edit.msgClass = 'text-success';
      } catch (err) {
        console.error('订单号 선택 → 표시사항 불러오기 실패:', err);
        this.edit.msg = '失败(실패): ' + err.message;
        this.edit.msgClass = 'text-danger';
      } finally {
        this.edit.busy = false;
      }
    },
    // 검색 결과 없이 붙여넣은 내용만으로 새로 등록
    openFromPaste() {
      this.openEdit(null);
      this.edit.paste = { show: true, text: this.search.text, result: null, target: 'both' };
      this.parsePaste();
    },
    parsePaste() {
      const r = parseLabelText(this.edit.paste.text);
      this.edit.paste.result = r;
      // 식품 표시(식품유형·소비기한·보관방법)면 식검, KC 표시(모델명·인증번호·제조연월)면 KC, 모르면 둘 다
      this.edit.paste.target = r.section || 'both';
    },
    fieldLabelOf(key) {
      if (!key || key === '기타') return FIELD_LABELS['기타'];
      return FIELD_LABELS[key] || key;
    },
    // 인식 결과를 폼에 넣는다 — 붙여넣은 값이 우선(덮어쓴다). 그 칸에 없는 항목·모르는 라벨은 그 칸의 「기타」로
    applyPaste() {
      const r = this.edit.paste.result;
      if (!r) return;
      if (r.title) this.edit.상품명 = r.title;
      if (this.edit.isNew && !this.edit.barcode && r.codeType === 'barcode') this.edit.barcode = r.code;
      const targets = this.edit.paste.target === 'both' ? ['food', 'kc'] : [this.edit.paste.target];
      targets.forEach(t => {
        const fields = t === 'food' ? FOOD_FIELDS : KC_FIELDS;
        const vals = toSection(r, fields.map(f => f.key));
        Object.keys(vals).forEach(k => { this.edit[t][k] = vals[k]; });
      });
      if (this.edit.paste.target !== 'both') this.edit.mode = this.edit.paste.target;
      this.edit.msg = '已应用粘贴内容，请确认后保存(붙여넣은 내용을 폼에 넣었습니다. 확인 후 저장하세요)';
      this.edit.msgClass = 'text-success';
    },
    // 이 화주+바코드의 韩文标签资料 한 줄을 지운다(2026-10-16 YZY) — 되돌릴 수 없어 확인창을 거친다
    async removeLabel() {
      if (!this.edit.companyid || !this.edit.barcode) return;
      if (!confirm('确定删除该客户+条码的全部韩文标签资料(食检/KC/卫生检疫标签、固定申报金额、确认英文品名、KC证书)吗？已生成的旧文件不变，删除后无法恢复。\n(이 화주·바코드의 한글표시 자료 전부 — 식검/KC/위생검역 라벨, 고정 申报金额, 확정 영문 품명, KC 서류 — 를 삭제합니다. 이미 만든 서류는 그대로이며 복구할 수 없습니다.)\n' + this.edit.companyid + ' | ' + this.edit.barcode)) return;
      this.edit.busy = true;
      this.edit.msg = '';
      try {
        const { data } = await axios.post('/api/coupassLabel/delete', { companyid: this.edit.companyid, barcode: this.edit.barcode });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '删除失败');
        this.edit.show = false;
        this.load();
      } catch (e) {
        console.error('韩文标签资料 삭제 실패:', e);
        this.edit.msg = '删除失败(삭제 실패): ' + e.message;
        this.edit.msgClass = 'text-danger';
      } finally {
        this.edit.busy = false;
      }
    },
    async save() {
      const fp = String(this.edit.fixedPriceUSD == null ? '' : this.edit.fixedPriceUSD).trim();
      if (fp && !(Number(fp) > 0)) {
        this.edit.msg = '申报金额必须是大于0的数字，或留空(신고금액은 0보다 큰 숫자이거나 비워 두세요)';
        this.edit.msgClass = 'text-danger';
        return;
      }
      this.edit.busy = true;
      this.edit.msg = '';
      try {
        const { data } = await axios.post('/api/coupassLabel/save', {
          companyid: this.edit.companyid, barcode: this.edit.barcode, 상품명: this.edit.상품명, food: this.edit.food, kc: this.edit.kc, hyg: this.edit.hyg, fixedPriceUSD: fp, confirmedNameEn: this.edit.confirmedNameEn
        });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        this.applyLabel(data.label);
        this.edit.show = false;
        this.load();
      } catch (e) {
        console.error('韩文标签 저장 실패:', e);
        this.edit.msg = '保存失败(저장 실패): ' + e.message;
        this.edit.msgClass = 'text-danger';
      } finally {
        this.edit.busy = false;
      }
    },
    async onKcFile(ev) {
      const files = Array.from((ev.target && ev.target.files) || []);
      ev.target.value = '';
      if (!files.length) return;
      this.edit.busy = true;
      this.edit.msg = '';
      try {
        for (const file of files) {
          const type = fileType(file);
          if (!['application/pdf', 'image/png', 'image/jpeg'].includes(type)) throw new Error(file.name + ' — 只支持 PDF·PNG·JPG(PDF·PNG·JPG 만)');
          const b64 = await fileToB64(file);
          const { data } = await axios.post('/api/coupassLabel/kcFile', {
            companyid: this.edit.companyid, barcode: this.edit.barcode, file: { name: file.name, type, data: b64 }
          });
          if (data.요청결과 !== '성공') throw new Error(file.name + ' — ' + ((data.error && data.error.errorMessage) || '上传失败'));
          this.edit.isNew = false;
          this.edit.kcFiles = (data.label && data.label.kcFiles) || [];
        }
        this.edit.msg = '已上传(올렸습니다)';
        this.edit.msgClass = 'text-success';
        this.load();
      } catch (e) {
        console.error('KC 인증서류 업로드 실패:', e);
        this.edit.msg = '上传失败(업로드 실패): ' + e.message;
        this.edit.msgClass = 'text-danger';
      } finally {
        this.edit.busy = false;
      }
    },
    async removeFile(f) {
      if (!confirm(f.name + ' — 删除这个KC证书?(이 인증서류를 삭제할까요?)')) return;
      this.edit.busy = true;
      try {
        const { data } = await axios.post('/api/coupassLabel/kcFileDelete', { companyid: this.edit.companyid, barcode: this.edit.barcode, fileId: f.fileId });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '删除失败');
        this.edit.kcFiles = (data.label && data.label.kcFiles) || [];
        this.load();
      } catch (e) {
        console.error('KC 인증서류 삭제 실패:', e);
        alert('删除失败(삭제 실패): ' + e.message);
      } finally {
        this.edit.busy = false;
      }
    },
    // 보관 파일은 箱单发票 보관 파일과 같은 곳 — 같은 내려받기 API
    async downloadFile(meta) {
      try {
        const { data } = await axios.post('/api/coupassInvoiceRecord/file', { fileId: meta.fileId });
        if (data.요청결과 !== '성공' || !data.file) throw new Error((data.error && data.error.errorMessage) || '没有文件(파일 없음)');
        const bin = atob(data.file.data);
        const u8 = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
        const a = document.createElement('a');
        a.href = URL.createObjectURL(new Blob([u8], { type: data.file.type }));
        a.download = data.file.name || 'KC证书';
        document.body.appendChild(a);
        a.click();
        setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
      } catch (e) {
        console.error('KC 인증서류 받기 실패:', e);
        alert('下载失败(다운로드 실패): ' + e.message);
      }
    },
    fmtDay(v) {
      if (!v) return '';
      const d = new Date(v);
      return isNaN(d) ? '' : d.toLocaleDateString();
    },
    fmtDate(v) {
      if (!v) return '';
      const d = new Date(v);
      return isNaN(d) ? '' : d.toLocaleString();
    }
  }
};
</script>

<style lang="scss" scoped>
.cpl {
  &__gap { gap: 8px; }
  &__search { background: #f8f9fb; }
  &__search-input { width: 520px; max-width: 100%; }
  &__result { max-height: 40vh; overflow-y: auto; }
  &__paste { background: #fffdf4; }
  &__tag { font-size: 70%; font-weight: normal; }
  // 입력된 칸 = 연한 초록, 비어 있는 칸 = 연한 노랑(색만으로 구분하지 않도록 「未填」 라벨 병기)
  &__filled { background-color: #eaf6ec; border-color: #5cb270; }
  &__empty { background-color: #fff8e1; border-color: #e0c36a; }
  &__preview td { vertical-align: top; }
  &__pre { white-space: pre-wrap; word-break: break-all; }
  &__table {
    max-height: 70vh;
    overflow-y: auto;
    table { overflow: visible; }
    thead th { position: sticky; top: 0; z-index: 2; }
  }
}
</style>
